import React from 'react';
import './OrderLayout.scss';
import { Route } from 'react-router-dom';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import OrderItemContainer from 'Components/OrderItem/OrderItemContainer';
import OrderHeaderContainer from 'Components/OrderHeader/OrderHeaderContainer';
import ScrollToTop from 'Components/Shared/ScrollToTop/ScrollToTop';

interface IProps {
  component?: any
  path?: string;
  exact?: boolean;
}

const OrderLayout: React.SFC<IProps> = ({ component: Component, ...rest }) => {
  return   (
    <Route { ...rest } render={ matchProps => (
      <div className='order-layout'>
        <ScrollToTop>
          <OrderHeaderContainer />
          <WrapperLayout style='content-order' justify='center' padding='lg'>
            <OrderItemContainer />
            <div className='box-container'>
              <Component { ...matchProps } />
            </div>
          </WrapperLayout>
        </ScrollToTop>
      </div>
    ) } />
  );
};

export default OrderLayout;


// WEBPACK FOOTER //
// ./src/layouts/OrderLayout/OrderLayout.tsx